import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'pop-unauthorized-access',
  templateUrl: './unauthorized-access.component.html',
  styleUrls: ['./unauthorized-access.component.less']
})
export class UnauthorizedAccessComponent {
  public constructor(private location: Location) {}

  public returnAction() {
    this.location.back();
  }
}
